export default __webpack_public_path__ + "static/media/flag_saint_martin.73be2e4b.svg";